import { useEffect, useState } from "react";
import { cmsCall } from "@/lib/cms";

let cache = null;
let inflight = null;

/** Publieke, prijsloze productlijst voor het virtuele schap. */
export function useSchap() {
  const [data, setData] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    inflight = inflight || cmsCall("GET", "/content/schap");
    inflight
      .then((res) => {
        cache = res;
        setData(res);
      })
      .catch(() => setData({ producten: [] }))
      .finally(() => setLoading(false));
  }, []);

  return { producten: data?.producten || [], loading };
}
